import { FC, SVGProps } from "react";
import { colors } from "styles/variables";

export const BlogPaginationArrow: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill={colors.primaryDeepBlue}
    {...props}
  >
    <path d="M0.933594 6.72266L0.269531 6.05859L0.933594 5.39453L4.68359 1.64453L5.34766 0.980469L6.67578 2.30859L6.01172 2.97266L3.86328 5.12109H16.793H17.7305V6.99609H16.793H3.86328L5.85547 9.02734L6.51953 9.69141L5.23047 11.0195L4.56641 10.3555L0.933594 6.72266Z" />
  </svg>
);
